import * as React from "react";
import { Button, Text } from "@fluentui/react-components";

const FileInputWithPreview = ({
	name,
	accept,
	buttonText = "Carica File",
	onFileSelected, // Callback opzionale per notificare il file selezionato
}) => {
	const inputRef = React.useRef(null);
	const [filePreview, setFilePreview] = React.useState(null);
	const [fileName, setFileName] = React.useState("");

	// Funzione per aprire il file picker
	const handleButtonClick = () => {
		inputRef.current?.click();
	};

	// Gestione della selezione del file
	const handleFileChange = (e) => {
		const file = e.target.files[0];
		if (file) {
			setFileName(file.name);

			// Se il file è un'immagine, genera l'anteprima
			if (file.type.startsWith("image/")) {
				const previewUrl = URL.createObjectURL(file);
				setFilePreview(previewUrl);
			} else {
				setFilePreview(null);
			}

			// Chiamata alla callback, se definita
			if (onFileSelected) {
				onFileSelected(file);
			}
		}
	};

	// Pulizia dell'object URL quando il componente viene smontato o il file cambia
	React.useEffect(() => {
		return () => {
			if (filePreview) {
				URL.revokeObjectURL(filePreview);
			}
		};
	}, [filePreview]);

	return (
		<div>
			{/* Input file nascosto */}
			<input
				ref={inputRef}
				type="file"
				name={name}
				accept={accept}
				onChange={handleFileChange}
				style={{ display: "none" }}
			/>

			{/* Pulsante Fluent UI per aprire il file picker */}
			<Button onClick={handleButtonClick}>{buttonText}</Button>

			{/* Visualizzazione del nome del file se presente */}
			{fileName && (
				<Text style={{ display: "block", marginTop: "10px" }}>{fileName}</Text>
			)}

			{/* Visualizzazione dell'anteprima se il file è un'immagine */}
			{filePreview && (
				<img
					src={filePreview}
					alt={fileName}
					style={{
						maxWidth: "200px",
						marginTop: "10px",
						border: "1px solid #ccc",
						borderRadius: "4px",
					}}
				/>
			)}
		</div>
	);
};

export default FileInputWithPreview;
